module.exports = __webpack_public_path__ + "static/media/schat-thumb.cd6eb397.png";